import { getCurrentUrl, replaceCurrentUrl } from '@ori/presentation-utils';

import { OPEN_QUERY_PARAM, OPEN_QUERY_PARAM_ALWAYS, OPEN_QUERY_PARAM_ONCE } from '../constants';

export const getOpenQueryParam = () => {
  const url = getCurrentUrl();

  return url.searchParams.get(OPEN_QUERY_PARAM);
};

export const getValidOpenQueryParam = () => {
  const queryParam = getOpenQueryParam();

  return queryParam === OPEN_QUERY_PARAM_ONCE || queryParam === OPEN_QUERY_PARAM_ALWAYS ? queryParam : undefined;
};

export const removeOpenQueryParam = () => {
  if (getOpenQueryParam()) {
    const url = getCurrentUrl();
    url.searchParams.delete(OPEN_QUERY_PARAM);
    replaceCurrentUrl(url);
  }
};

export const setOpenQueryParam = () => {
  const url = getCurrentUrl();
  url.searchParams.set(OPEN_QUERY_PARAM, OPEN_QUERY_PARAM_ONCE);
  if (url.searchParams.get(OPEN_QUERY_PARAM) !== getOpenQueryParam()) {
    replaceCurrentUrl(url);
  }
};
